/** The surface every tile of the widget bar shares. Colours come from the theme. */
export const WIDGET_TILE_CLASS =
  'flex h-full w-full box-border rounded-[20px] border border-[var(--window-border-color)] bg-[var(--window-background)] text-[var(--text-color)]'

/** Tile height per widget in the wide size; a small tile is always 150px. */
const WIDE_HEIGHT: Partial<Record<string, string>> = {
  clock: 'h-[112px]',
  calendar: 'h-[172px]',
}

export const widgetCellClass = (widgetId: string, size: string) =>
  size === 'small' ? 'h-[150px]' : `col-span-2 ${WIDE_HEIGHT[widgetId] ?? 'min-h-[124px]'}`
